<template>
  <footer v-if="config" :class="[$style.container, { [$style.shop]: config.type === 'shop' }]">
    <WishList v-if="config.wishList" :config="config.wishList" />
    <div v-if="config.badges" :class="[$style.badges, 'columns is-mobile is-multiline']">
      <div
        v-for="(badge, index) in config.badges"
        :key="index"
        class="column is-half-mobile is-one-fifth-tablet"
      >
        <img alt="" :class="[badge.image.class]" :src="badge.image.src" />
        <p>
          <strong>{{ badge.headline }}</strong>
          {{ badge.text }}
        </p>
      </div>
    </div>
    <div :class="[$style.main, 'columns', 'is-multiline', 'is-variable', 'is-5']">
      <template v-for="(col, index) in config.columns" :key="index">
        <NewsletterQuickSubscription v-if="col.newsletter" :config="col.newsletter" />
        <div
          v-else-if="col.genericLinks"
          :class="[$style.links, 'column', 'is-half-tablet', 'is-one-quarter-desktop']"
        >
          <ul>
            <li v-for="(link, linkIndex) in col.genericLinks" :key="linkIndex">
              <a v-bind="linkAttributes(link)" v-html="link.content" />
            </li>
          </ul>
        </div>
        <div
          v-else
          :class="[col.class, 'column', 'is-half-tablet', 'is-one-quarter-desktop']"
          v-html="col.content"
        />
      </template>
    </div>
    <div :class="[$style.nav, 'columns', 'is-vcentered', 'is-multiline', 'is-variable', 'is-5']">
      <div :class="[$style.copyright, 'column']" v-html="config.copyright" />
      <SocialLinks :social-links="config.socialLinks" />
    </div>
  </footer>
</template>

<script setup>
import { nextTick } from 'vue'
import SocialLinks from '../SocialLinks/SocialLinks.vue'
import WishList from '../WishList/WishList.vue'
import NewsletterQuickSubscription from '../NewsletterQuickSubscription/NewsletterQuickSubscription.vue'
import { linkAttributes } from '../../utils/helper'

defineProps({
  config: {
    type: Object,
    default: () => {}
  }
})

nextTick(() => {
  document.querySelectorAll('.TextTeaser__text').forEach((el) => {
    const inner = el.querySelector('#textTeaserTextInner_')
    if (inner && !inner.textContent.trim()) {
      el.style.display = 'none'
    }
  })
})

</script>

<style module lang="scss">
@import './Footer.scss';
</style>
